export default "__VITE_ASSET__e5690120__"